"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserType = exports.TRACKING_PARAMETERS = void 0;
/**
 * A constant array of tracking parameters used for identifying the source and context of web traffic.
 * Typically encoded in the UTM cookie in a browser.
 *
 * @remarks
 * Any params added here must be added to validateSearchParams in booking-ui/src/common/search.ts
 */
exports.TRACKING_PARAMETERS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "gclid",
    "fbclid",
    "msclid",
    "ttclid",
    "referral_url",
    "lead_source",
    "landing_page_url",
];
/**
 * Enum representing different types of users.
 *
 * @enum {string}
 * @property {string} PATIENT - Patient or potential patient.
 * @property {string} PROVIDER - Provider, which can be any sub-type (e.g. therapist).
 * @property {string} INSURER - Insurer, not currently in-use.
 * @property {string} OPERATOR - Operator or any internal non-developer.
 * @property {string} DEVELOPER - Developer; mostly relevant for backfills or manual intervention.
 * @property {string} SYSTEM - System, either first-party or third-party.
 * @property {string} AGENT - Third-party agent (e.g. a call center agent).
 * @property {string} PCP - PCP (Primary Care Physician).
 */
var UserType;
(function (UserType) {
    UserType["PATIENT"] = "Patient";
    UserType["PROVIDER"] = "Provider";
    UserType["INSURER"] = "Insurer";
    UserType["OPERATOR"] = "Operator";
    UserType["DEVELOPER"] = "Developer";
    UserType["SYSTEM"] = "System";
    UserType["AGENT"] = "Agent";
    UserType["PCP"] = "PCP";
})(UserType || (exports.UserType = UserType = {}));
//# sourceMappingURL=identify.js.map